<template>
    <p class="field-title">{{ label }}
        <TooltipComponent v-if="placeholder" :description="placeholder" />
    </p>
    <TreeSelect :disabled="disableEdit" :modelValue="selectedValue" :options="options" :placeholder="placeholder"
        selectionMode="checkbox" @update:modelValue="handleInput" display="chip" panelClass="p-tree-checkbox" />
    <p v-if="v$.selectedValue.$error" class="error-msg">{{ error_message }}</p>
</template>

<script>
import { ref, watch, computed } from 'vue';
import TreeSelect from 'primevue/treeselect';
import { minLength, required } from '@vuelidate/validators';
import TooltipComponent from './TooltipComponent.vue';
import { useVuelidate } from '@vuelidate/core';

export default {
    name: 'TreeSelectDropdownComponent',
    components: {
        TreeSelect,
        TooltipComponent,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        item: {
            type: Object,
            required: true,
        },
        error_message: {
            type: String,
        },
        validation_rules: {
            type: Object,
            default: () => ({}),
        },
        disableEdit: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, { emit }) {
        const selectedValue = ref(props.modelValue);

        const rules = computed(() => {
            const validationRules = {};
            if (props.validation_rules.minLength) {
                validationRules.minLength = minLength(props.validation_rules.minLength);
                //validationRules.required = required;
            }
            return {
                selectedValue: validationRules,
            };
        });

        const v$ = useVuelidate(rules, { selectedValue });

        watch(
            () => props.modelValue,
            (newVal) => {
                selectedValue.value = newVal;
                v$.value.$touch();

                if (!v$.value.selectedValue.$error) {
                    emit('isValid', true);
                } else {
                    emit('isValid', false);
                }
            }
        );

        const handleInput = (newValue) => {
            selectedValue.value = newValue;
            emit('update:modelValue', newValue);
            v$.value.$touch();
            if (!v$.value.selectedValue.$error) {
                emit('isValid', true);
            } else {
                emit('isValid', false);
            }
        };

        return { selectedValue, v$, handleInput };
    },
};
</script>
